import StandardResponse from '../../models/standard-response';
import BaseService from '../../services/base-service';
import type {
    IChargeSessionStatusRequest,
    IChargeSessionStatusResponse,
    IExportChargePaymentHistoryRequest,
    IStopSessionRequest,
    IStopSessionResponse,
    IVatReceipt,
    PaymentStatus,
} from '../../models/charging';
import type {
    IChargeSessionPaymentStatusRequest,
    IChargeSessionPaymentStatusResponse,
    IPaymentInvoiceResponse,
    ISettlementPaymentInvoiceRequest,
} from '../../models/payment';

export const getChargingAuthorisationStatus = async (
    data: IChargeSessionStatusRequest,
): Promise<StandardResponse<IChargeSessionStatusResponse>> => {
    try {
        const res = await BaseService({
            url: `web-pay/charge-sessions/get-session-status`,
            method: 'POST',
            data: { ...data, hideSpinner: true },
        });

        return new StandardResponse<IChargeSessionStatusResponse>(res.status, res.data.data, res.data.message, '');
    } catch (e) {
        return Promise.reject(e);
    }
};

export const stopCharge = async (data: IStopSessionRequest): Promise<StandardResponse<IStopSessionResponse>> => {
    try {
        const res = await BaseService({
            url: `web-pay/charge-sessions/stop-session`,
            method: 'POST',
            data,
        });

        return new StandardResponse<IStopSessionResponse>(res.status, res.data.data, res.data.message, '');
    } catch (e) {
        return Promise.reject(e);
    }
};

export const getDownloadReceiptData = async (
    data: IExportChargePaymentHistoryRequest,
): Promise<StandardResponse<IVatReceipt>> => {
    try {
        const res = await BaseService({
            url: `web-pay/charge-sessions/charge-payment-history/export`,
            method: 'POST',
            data,
        });

        return new StandardResponse<IVatReceipt>(res.status, res.data.data, res.data.message, '');
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getPaymentDetails = async (
    data: IChargeSessionPaymentStatusRequest,
): Promise<StandardResponse<PaymentStatus[]>> => {
    try {
        const res = await BaseService({
            url: `web-pay/payment/status`,
            method: 'POST',
            data,
        });

        return new StandardResponse<PaymentStatus[]>(res.status, res.data.data, res.data.message, '');
    } catch (err) {
        return Promise.reject(err);
    }
};

export const createSettlementPaymentInvoice = async (
    data: ISettlementPaymentInvoiceRequest,
): Promise<StandardResponse<IPaymentInvoiceResponse>> => {
    try {
        const res = await BaseService({
            url: 'web-pay/payment/create/settlement/invoice',
            method: 'POST',
            data,
        });
        return new StandardResponse<IPaymentInvoiceResponse>(res.status, res.data.data, res.data.message, '');
    } catch (e) {
        return Promise.reject(e);
    }
};

export const tryAgainPayment = async (
    data: IChargeSessionPaymentStatusRequest,
): Promise<StandardResponse<IChargeSessionPaymentStatusResponse>> => {
    try {
        const res = await BaseService({
            url: 'web-pay/payment/perform/settlement',
            method: 'POST',
            data,
        });
        return new StandardResponse<IChargeSessionPaymentStatusResponse>(
            res.status,
            res.data.data,
            res.data.message,
            '',
        );
    } catch (e) {
        return Promise.reject(e);
    }
};
